import { SharePointListClient, type ListItem } from '../SharePointListClient';

/**
 * 99.ABM_Retenciones — catalogue of tax-retention regimes. Read-only in this
 * pass; surfaced as a lookup in the Proveedores form (Concepto_P).
 */
export type RetencionesFields = {
  Title?: string | null;
  CodigoRegimen_R?: string | null;
  Concepto_R?: string | null;
  ConcatCodigoRegimenConcepto_R?: string | null;
  RetencionInscriptos_R?: string | null;
  RetencionNoInscriptos_R?: string | null;
  MontosNoSujetosRetencion_R?: string | null;
  Status_R?: 'Activo' | 'Inactivo' | string | null;
};

export type RetencionItem = ListItem<RetencionesFields>;

export const retencionesClient = new SharePointListClient<RetencionesFields>('ABM_Retenciones');

export async function listActiveRetenciones(): Promise<RetencionItem[]> {
  return retencionesClient.listItems({
    filter: "fields/Status_R eq 'Activo'",
    orderBy: 'fields/CodigoRegimen_R asc',
  });
}
